import { type FC } from 'react'
import classNames from 'classnames'
import { Spinner } from 'react-bootstrap'

interface LoadingScreenProps {
  message: string
  compact?: boolean
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ message, compact = false }) => (
  <div className={classNames('d-flex flex-column align-items-center justify-content-center zocks-gap-0.75 w-100', compact ? 'zocks-py-2.0' : 'zocks-py-5.0')}>
    <Spinner variant='primary' />
    <p className='paragraph-medium medium mb-0'>{message}</p>
  </div>
)
